/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setSessionData, getUserIP, setAuthData, storeSessionData } from 'state/actions/session_status.js';
import { getUserPermissions, extendSession } from 'state/actions/auth_status';
import { setAuthTokenData } from 'state/actions/auth_status';
import { getPaymentInformation, getShowPubPortalV2Button } from 'state/actions/accountState/account_data';
import { getAllSites } from 'state/actions/accountState/account_data';

import { getCommentingData, checkForCommentingUnit, getCommentingEmailIfExist } from 'state/actions/commentingState/commentingStatus';
import { checkForRatingsUnit } from 'state/actions/ratingsState/ratingsStatus';
import { updatePageDetails, changePage } from '@insticator/insticator-ui'
import {displayModal, displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
import { signOut, unmockUser } from 'state/actions/auth_status';
// component
import App from 'app';



/* ========== ~~~~~~~~~~ APP : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = (props) => {
    const { sessionStatus,  appStatus, embedsState, userStatus, accountData, commentingState } = props;
    return {
        embedsState,
        sessionStatus,
        appStatus: appStatus,
        currentPage: appStatus.currentPage,
        userLoggedIn: userStatus.loggedIn,
        accountUUID: sessionStatus.accountUUID,
        userUUID: sessionStatus.userUUID,
        isSignedIn: sessionStatus.isSignedIn,
        showTermsAndConditions: sessionStatus.showTermsAndConditions,
        agreementUUID: sessionStatus.agreementUUID,
        authFail: sessionStatus.authFail,
        mocked: sessionStatus.mocked,
        mockupGenerator: sessionStatus.mockupGenerator,
        productCategory: sessionStatus.productCategory,
        siteUUID: sessionStatus.siteUUID,
        permissions: sessionStatus.permissions,
        queryParams: sessionStatus.queryParams,
        sites: accountData.sites,
        lastActionDispatchedAt: sessionStatus.lastActionDispatchedAt,
        sessionStartTime: sessionStatus.sessionStartTime,
        isCommentingDataReceived: commentingState.commentingStatus.isDataReceived,
        showSetPassword: sessionStatus.showSetPassword,
        showPubPortalV2Button: accountData.showPubPortalV2Button,
        userEmail: sessionStatus.userEmail
    }
};
// map actions
const mapDispatchToProps = dispatch => ({
    setSessionData: sessionData => dispatch(setSessionData(sessionData)),
    extendSession: () => dispatch(extendSession()),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    getUserIP: () => dispatch(getUserIP()),
    getUserPermissions: (userUUID) => dispatch(getUserPermissions(userUUID)),
    setAuthTokenData: data => dispatch(setAuthTokenData(data)),
    displayErrorMessage: errorMessage => dispatch(displayErrorMessage(errorMessage)),
    displaySuccessMessage: successMessage => dispatch(displaySuccessMessage(successMessage)),
    getAllSites: accountUUID => dispatch(getAllSites(accountUUID)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    updatePageDetails: location => dispatch(updatePageDetails(location)),
    signOut: () => dispatch(signOut()),
    unmockUser: () => dispatch(unmockUser()),
    checkForRatingsUnit: siteUUID => dispatch(checkForRatingsUnit(siteUUID)),
    checkForCommentingUnit: siteUUID => dispatch(checkForCommentingUnit(siteUUID)),
    getCommentingData: accountUUID => dispatch(getCommentingData(accountUUID)),
    setAuthData: response => dispatch(setAuthData(response)),
    storeSessionData: sessionData => dispatch(storeSessionData(sessionData)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    getShowPubPortalV2Button: accountUUID => dispatch(getShowPubPortalV2Button(accountUUID)),
    getCommentingEmailIfExist: email => dispatch(getCommentingEmailIfExist(email))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
